'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NitroButton = require('./NitroButton');

var _NitroButton2 = _interopRequireDefault(_NitroButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _NitroButton2.default;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-button/index.js
// module id = 20
// module chunks = 4